import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import CartItem from './CartItem';

////////////////////////////////////////////
// TODO MISSING TESTS
////////////////////////////////////////////

function CartAdditionalProduct(props) {
  const { additionalProduct, eventNames, ...other } = props;
  return (
    <CartItem
      title={additionalProduct.type}
      finalPrice={additionalProduct.price || 0}
      hasAddToCartOption={true}
      hasDeleteOption={false}
      eventNames={eventNames}
      {...other}
    />
  );
}

CartAdditionalProduct.propTypes = {
  additionalProduct: PropTypes.object,
  eventNames: PropTypes.object,
};

export { CartAdditionalProduct };

export default createFragmentContainer(CartAdditionalProduct, {
  additionalProduct: graphql`
    fragment CartAdditionalProduct_additionalProduct on Product {
      price
    }
  `,
});
